import { isCustomizedType, reduce } from "et3-type-guards";

import i18nServerResponse from "../../constants/i18n-server-response";
import getCoreHistoryStore from "../../stores/core/core-history-store";
import getCorePersonalStore from "../../stores/core/core-personal-store";
import { TPoolTable } from "../../Types";
import { post } from "../axios-post";

export const apiCallCleanAdminPoolByType = async ({
  poolType
}: {
  poolType: TPoolTable;
}) => {
  const adminId = getCorePersonalStore().user.get().id;
  const pageName = getCoreHistoryStore().pageName.get();

  const { status, data, et3Error } = await post<{ totalDeleted: number }>(
    `core/cleanAdminPoolByType`,
    {
      adminId,
      pageName,
      poolType
    }
  );
  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      status: "OK",
      data: data.totalDeleted
    };
  } else {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: 0,
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  }
};
